import { service,BASE_API } from '@/utils/request'
import { searchParamsFormatter } from '@/api/common'

const v2 = BASE_API

export default {
	// 分页
	get(data) {
		return service({
			url: '/cloud/course/v1/admin/guide/search',
			method: 'post',
			data
		})
	},
	// 新增
	add(data) {
		return service({
			url: '/cloud/course/v1/admin/guide/add',
			method: 'post',
			data
		})
	},
	// 更新
	update(path, data) {
		return service({
			url: '/cloud/course/v1/admin/guide/update/' + path,
			method: 'post',
			data
		})
	},
	// 删除
	delete(path, data) {
		return service({
			url: '/cloud/course/v1/admin/guide/remove/' + path,
			method: 'post',
			data
		})
	},
	// 删除
	getById(path) {
		return service({
			url: '/cloud/course/v1/admin/guide/get/' + path,
			method: 'get'
		})
	},
	// 上下架
	switch(path, data) {
		return service({
			url: '/cloud/course/v1/admin/guide/statusChange/' + path,
			method: 'post',
			data
		})
	},
	// 资料
	// 分页
	get_material(path) {
		return service({
			url: '/cloud/course/v1/admin/guideMaterial/all/' + path,
			method: 'post'
		})
	},
	// 新增
	add_material(path, data) {
		return service({
			url: '/cloud/course/v1/admin/guideMaterial/add/' + path,
			method: 'post',
			data
		})
	},
	// 更新
	update_material(path, data) {
		return service({
			url: '/cloud/course/v1/admin/guideMaterial/update/' + path,
			method: 'post',
			data
		})
	},
	// 删除
	delete_material(path, data) {
		return service({
			url: '/cloud/course/v1/admin/guideMaterial/remove/' + path,
			method: 'post',
			data
		})
	},
	// 搜索制定者
	search_framer(data) {
		return service({
			url: '/cloud/course/v1/admin/guideFramer/filters',
			method: 'post',
			data
		})
	},
  down: 'https://file.ibabygroup.cn/adminTemplate/GuideMemberImportTemplate.xlsx',
  excelUpload: BASE_API + '/cloud/course/v1/admin/guideMember/importByExcel/',
	getSignatureUrl: () => {
		return BASE_API + '/cloud/uac/proxy/Common/GetVodUploadSign';
	},
}



// WEBPACK FOOTER //
// ./src/api/operateManage/guidemanage.js